export interface KYCProfile {
    summary_status: KYCStatus;
    corporate_profile?: KYCCorporateProfile;
    private_profile?: KYCPrivateProfile;
}

export interface KYCCorporateProfile {
    company_status: KYCStatus;
    company: KYCCompany;
    signatories: [KYCSignatory];
    directors: [KYCDirectorOrShareholder];
    shareholders: [KYCDirectorOrShareholder];
}

export interface KYCPrivateProfile {
    person: KYCPerson;
}

export interface KYCSignatory {
    status: KYCStatus;
    person: KYCPerson;
}

export interface KYCDirectorOrShareholder {
    status: KYCStatus;
    person?: KYCPerson;
    company?: KYCCompany;
}

export interface KYCStatus {
    verification_date: string;
    result: KYCStatusResult;
}

export interface KYCPerson {
    id: number;
    first_name: string;
    last_name: string;
    dob: string;
    nationality: string;
    address: string;
    link: string;
}

export interface KYCCompany {
    name: string;
    type: string;
    registration_number: number;
    registered_office_country: string;
    link: string;
}

export enum KYCStatusResult {
    NOT_VERIFIED = 'NOT_VERIFIED',
    IN_PROGRESS = 'IN_PROGRESS',
    CLEAR = 'CLEAR',
    AML_FOUND = 'AML found',
    INVALID = 'INVALID',
    INCOMPLETE_DATA = 'INCOMPLETE_DATA'
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/entity/kyc-verification.ts